import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { INTEGRATION_PARTNER_ROLE } from '../../services/dashboard-data.service';

@Injectable({
  providedIn: 'root'
})
export class IntegrationPartnerGuard {

  constructor(private route: Router, private localStorageService: LocalStorageService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const role = this.localStorageService.getRole();
    if (role !== INTEGRATION_PARTNER_ROLE) {
      if (!role || role === 'guest') {
        this.route.navigateByUrl('/welcome');
      } else if (role === 'Consumer' || role === 'Prosumer') {
        this.route.navigateByUrl('/market');
      } else if (role === 'Utility') {
        this.route.navigateByUrl('/homepage');
      } else if (role === 'SuperAdmin') {
        this.route.navigateByUrl('/admin-dash/dashboard');
      } else if (role === 'ServiceProvider') {
        this.route.navigateByUrl('/provider-dash');
      } else {
        this.route.navigateByUrl('/welcome');
      }
      return false;
    }
    return true;
  }
}
